import React, { useState, useEffect } from "react";
import { Select, Input, Spin } from "antd";
import { useDispatch, useSelector } from "react-redux";
import Profile from "../../../../assets/Sidebar/Profile_Pic.svg";
import { DownOutlined } from "@ant-design/icons";
import logo from "../../../../assets/Locobuzz_Blue_Logo.svg";
import accoArrow from "../../../../assets/acco_arrow-up.svg";
import {
  getShareSearchTeamList,
  setSharableUserData,
} from "../../../../redux/actions/ApiCall/apiCall";
import { getPaneIndex } from "../../../../redux/constants";
import useDebounce from "../../../layout/WelcomePage/Worksheets/useDebounce";
import { LoadingOutlined } from "@ant-design/icons";

const { Option } = Select;
const children = [];

const ShareDropdown = ({
  selectedUserId,
  setSelectedUserId,
  setDeselectId,
}) => {
  const dispatch = useDispatch();

  const shareableUserData = useSelector(
    (state) => state?.ApiCall?.shareableUserData
  );
  const shareableUserDataLoader = useSelector(
    (state) => state?.ApiCall?.shareableUserDataLoader
  );
  const shareableData = useSelector((state) => state.dashboard.shareableData);

  const authParams = useSelector((state) => state.Authentication.authParams);
  const panes = useSelector((state) => state?.Tab1?.panes);
  const activeKey = useSelector((state) => state?.Tab1?.activeKey);
  let index = getPaneIndex(panes, activeKey);

  const [searchTextData, setSearchTextData] = useState();
  const debouncedUpdateTitle = useDebounce(searchTextData, 1000);

  useEffect(() => {
    if (debouncedUpdateTitle) {
      let shareObject = {
        authParams: authParams,
        template_id: shareableData?.template_id
          ? shareableData?.template_id
          : panes?.[index]?.template_id,
        search_string: searchTextData,
      };
      dispatch(getShareSearchTeamList(shareObject));
    } else {
      if (debouncedUpdateTitle === "") {
        let shareObject = {
          authParams: authParams,
          template_id: shareableData?.template_id
            ? shareableData?.template_id
            : panes?.[index]?.template_id,
          search_string: searchTextData,
        };
        dispatch(setSharableUserData(null));
      }
    }
  }, [debouncedUpdateTitle]);

  const handleChange = (id) => {
    setSelectedUserId(id);
  };

  const handleDeSelect = (id) => {
    setDeselectId(id);
  };

  function onBlur() {}

  function onFocus() {}

  function onSearch(val) {
    setSearchTextData(val);
  }
  return (
    <Select
      showArrow={true}
      showSearch
      optionFilterProp={searchTextData}
      onFocus={onFocus}
      onBlur={onBlur}
      onSearch={onSearch}
      className="sharable-dropdown border-color"
      mode="multiple"
      style={{
        width: "100%",
        // height: "4.2rem",
      }}
      placeholder="Search accounts based on name or user name"
      defaultValue={selectedUserId}
      onChange={handleChange}
      onDeselect={handleDeSelect}
      listItemHeight={10}
      listHeight={160}
      filterOption={false}
      notFoundContent={
        shareableUserDataLoader ? (
          <div className="loader text-center w-100" style={{ height: "15rem" }}>
            <Spin
              indicator={<LoadingOutlined style={{ fontSize: 24 }} spin />}
            />
          </div>
        ) : shareableUserData?.length === 0 ? (
          "No users Found"
        ) : (
          ""
        )
      }
      searchValue={searchTextData}
      dropdownClassName={
        authParams?.theme_type === "1" ? "darkTheme" : "lightTheme"
      }
      // notFoundContent= "No users Found"
    >
      {!shareableUserDataLoader &&
        shareableUserData?.map(
          (d, i) =>
            d?.first_name && (
              <Option
                key={i}
                value={d.user_id}
                nickname={d.first_name + " " + d.last_name}
              >
                <div className="d-flex align-items-center justify-content-between">
                  <div className="d-flex align-items-center">
                    <img
                      src={Profile}
                      style={{ maxWidth: "1.8rem" }}
                      className="mr-1"
                      alt="Profile"
                    />
                    <div className="font-weight500 text_regular">
                      {d.first_name} {d.last_name}{" "}
                      <span className="text_regular-gray font-size12 font-weight400">
                        ({d?.User_Name})
                      </span>
                    </div>
                    <div className="d-none">
                      <div className="text_regular">{d.email}</div>
                    </div>
                  </div>
                </div>
              </Option>
            )
        )}
    </Select>
  );
};

export default ShareDropdown;
